export default function ToggleSet({ translations }: { translations: any }) {
  return (
    <div className="mb-4 shadow-sm">
      <a
        href="https://docs.google.com/forms/d/e/1FAIpQLSeQ9Lzh-yeojb-0cjyObupf8oQYVqS948gFg80MXSkEABUegQ/viewform"
        target="_blank"
        rel="noopener noreferrer"
        className="flex cursor-pointer justify-center border-[0.5px] border-[#3C3C3C] bg-[#2B2D31] py-4 text-sm font-bold text-[#3796F6] sm:rounded-lg"
      >
        {translations.giveFeedback}
      </a>
    </div>
  );
}
